import React from 'react';

import PropTypes from 'prop-types';
import { Checkbox } from '@telus-uds/components-web';

import { CONSTANT } from '../../../../../utils/constant';
import { isAdmin } from '../../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

// SOF1 / SOF-3356 T031 — Manage Account: dealership-wide order visibility flag.
// Render conditions (all required):
//   (a) target user role === SALES_MANAGER
//   (b) target user channels[0] === DEALER
//   (c) logged-in user has Admin role (FR-010)
// Backend (T030) re-enforces (c) and returns 403 otherwise. This component
// must be rendered ABOVE the Available Forms (AccessControl) section in
// form.js per spec.
const DealershipVisibility = ({ fieldData, setFieldData }) => {
  const {
    KEYS: {
      ROLES: { SALES_MANAGER },
      CHANNELS: { DEALER }
    }
  } = CONSTANT;

  const localizedStrings = useLocalizedStringsContext();

  const targetIsSm = fieldData.role === SALES_MANAGER;
  const targetIsDealer =
    Array.isArray(fieldData.channels) && fieldData.channels[0] === DEALER;

  if (!targetIsSm || !targetIsDealer || !isAdmin) return null;

  const labelFromContext =
    localizedStrings &&
    localizedStrings.USERS &&
    localizedStrings.USERS.FORM &&
    localizedStrings.USERS.FORM.LABEL &&
    localizedStrings.USERS.FORM.LABEL.DEALERSHIP_VISIBILITY_LABEL;
  const label = labelFromContext || 'Enable Order Visibility for Entire Dealership';

  return (
    <Checkbox
      checked={Boolean(fieldData.dealershipVisibilityEnabled)}
      onChange={() => {
        setFieldData(previousValue => ({
          ...previousValue,
          dealershipVisibilityEnabled: !previousValue.dealershipVisibilityEnabled
        }));
      }}
      name="dealershipVisibilityEnabled"
      value="dealershipVisibilityEnabled"
      label={label}
    />
  );
};

DealershipVisibility.propTypes = {
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    id: PropTypes.number,
    role: PropTypes.string,
    channels: PropTypes.arrayOf(PropTypes.string),
    dealershipVisibilityEnabled: PropTypes.bool
  }).isRequired
};

export default DealershipVisibility;
